import PackageForm from "@/features/packages/components/PackageForm";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { useEditPackage, usePackageByIdQuery } from "../hooks/usePackages";
import HeadLayout from "@shared/layouts/HeadLayout";

const EditPackage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, mutate, isPending } = useEditPackage();
  const { data: packageData, isLoading, isError } = usePackageByIdQuery(id);

  const navigate = useNavigate();
  const handleSubmit = (data) => {
    const toastId = toast.loading(t("toast.updatingPackage"));
    console.log("data", data);
    mutate(
      {
        id,
        values: data,
      },
      {
        onSuccess: () => {
          toast.success(`Package updated`, {
            id: toastId,
          });
          navigate("/packages");
        },
        onError: (error) => {
          toast.error(`${error.response.data.message}`, {
            id: toastId,
          });
        },
      }
    );
  };

  if (isLoading) {
    return <div>{t("common.loading")}</div>;
  }

  return (
    <>
      <HeadLayout title={"packages.editPackage"} />
      <div className="bg-background p-4 rounded-xl">
        <PackageForm
          onSubmit={handleSubmit}
          initialData={packageData}
          action={"update"}
          actionIsLoading={isPending}
        />
      </div>
    </>
  );
};

export default EditPackage;
